import { useEffect, useState } from 'react';
import { type ITexture } from '@/version-types';
import { type TextureConfig } from '../types';
import { getTextureUrl } from '../utils';

export const useTexture = (texture: ITexture | null | undefined) => {
    const [textureConfig, setTextureConfig] = useState<TextureConfig | null>(null);

    useEffect(() => {
        if (!texture?.url) {
            setTextureConfig(null);
            return;
        }

        const url = getTextureUrl(texture.url);
        const img = new Image();

        img.onload = () => {
            setTextureConfig({
                width: img.width,
                height: img.height,
                url,
                stretch: texture.stretch,
            });
        };

        img.src = url;
    }, [texture?.url, texture?.stretch]);

    return {
        textureConfig,
    };
};
